// PARAQTA — Marathon беті (Stage 6.9.2 → Stage 10 сайт ішілік тіркеу).
// Pattern: Bot MySQL READ + сайт Kaspi тіркеу (marathon_orders, бот тимеу).

import { api } from '../../core/api.js';
import { show } from '../../core/router.js';
import { esc } from '../../utils/format.js';
import { injectQuizCard } from '../marathon-quiz/index.js';
import { shareNumberCard, injectCertCard } from '../marathon-card/index.js';
import { showLoginModal } from '../auth/login-modal.js';

const root = () => document.getElementById('pg-marathon');

// Реф коды (localStorage pq_ref) — жеңілдік бағасын (800₸) қонаққа да көрсету үшін
// backend-ке жіберіледі (логинге тәуелсіз, батырма мен Kaspi да 800 болсын).
function _refCode() {
  try { return (localStorage.getItem('pq_ref') || '').trim(); } catch (_) { return ''; }
}
function _currentUrl() {
  const c = _refCode();
  return '/api/marathon/current' + (c ? '?ref=' + encodeURIComponent(c) : '');
}

// Ағымдағы марафон (модал қолданады) + таңдалған чек файлы + жас тобы.
let _m = null;
let _regFile = null;
let _regBand = null;

const MONTHS_KK = [
  'қаңтар', 'ақпан', 'наурыз', 'сәуір', 'мамыр', 'маусым',
  'шілде', 'тамыз', 'қыркүйек', 'қазан', 'қараша', 'желтоқсан',
];

function fmtDateRange(startISO, endISO) {
  if (!startISO || !endISO) return '';
  const s = new Date(startISO);
  const e = new Date(endISO);
  if (isNaN(s) || isNaN(e)) return '';
  if (s.getMonth() === e.getMonth()) {
    return `${s.getDate()}–${e.getDate()} ${MONTHS_KK[s.getMonth()]}`;
  }
  return `${s.getDate()} ${MONTHS_KK[s.getMonth()]} – ${e.getDate()} ${MONTHS_KK[e.getMonth()]}`;
}

// "15 маусым" түрінде бір күн (тіркелу ашылуы үшін).
function fmtDay(ymd) {
  if (!ymd) return '';
  const [y, m, d] = String(ymd).split('-').map(Number);
  if (!y || !m || !d) return '';
  return `${d} ${MONTHS_KK[m - 1]}`;
}

// Бүгінгі жергілікті күн YYYY-MM-DD (лексикографиялық салыстыру үшін).
function todayYMD() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

// Күнге дейін қалған толық күн саны (бүгін=0).
function daysUntil(ymd) {
  if (!ymd) return null;
  const [y, m, d] = String(ymd).split('-').map(Number);
  if (!y || !m || !d) return null;
  const target = new Date(y, m - 1, d);
  const now = new Date(); now.setHours(0, 0, 0, 0);
  return Math.round((target - now) / 86400000);
}

// Марафон фазасы: before_reg → reg_open → live → ended.
function marathonPhase(m) {
  const t = todayYMD();
  const ro = m.reg_open_date, s = m.start_date, e = m.end_date;
  if (ro && t < ro) return 'before_reg';   // тіркелу әлі ашылмаған
  if (s && t < s) return 'reg_open';        // тіркелу ашық, марафон басталмаған
  if (e && t <= e) return 'live';           // марафон жүріп жатыр
  if (e && t > e) return 'ended';           // аяқталды
  return 'reg_open';
}

function topNav() {
  return `
    <nav class="v2-top-nav">
      <button class="v2-nav-btn" data-action="marathon-back" aria-label="Артқа">
        <i class="ti ti-arrow-left"></i>
      </button>
      <div class="v2-nav-title">Marathon</div>
      <button class="v2-nav-btn" data-action="theme-toggle">
        <i class="ti ti-moon" style="font-size: 14px; opacity: 0.6;"></i>
      </button>
    </nav>
  `;
}

function renderEmpty() {
  return `
    ${topNav()}
    <div class="mr-empty">
      <i class="ti ti-flame"></i>
      <h2>Marathon әзірге жоқ</h2>
      <p>Жуырда жаңасы — арнадан хабар.</p>
      <a href="https://t.me/paraqta_oqy" target="_blank" rel="noopener" class="mr-empty-btn">
        <i class="ti ti-brand-telegram"></i> @paraqta_oqy
      </a>
    </div>
  `;
}

// CTA — марафон фазасына қарай (тіркелу ашылмаған / ашық / тексеруде / тіркелген / жүріп жатыр / аяқталды).
function renderCta(m, phase, regDay, priceFmt, botUrl) {
  // 1) Тіркелген — нөмір + "ішіндесіз" + бөлісу + (бар болса) Telegram тобы.
  if (m.is_registered && phase !== 'ended') {
    const numHtml = m.my_number
      ? `<div class="mr-num-badge">Сенің нөмірің <b>#${m.my_number}</b></div>` : '';
    const shareBtn = m.my_number
      ? `<button class="mr-cta-btn mr-cta-share" data-action="share-number" style="margin-top:10px;"><i class="ti ti-share"></i> Нөмірімді бөлісу</button>` : '';
    const invite = m.tg_invite ? `
      <div style="margin-top:12px;padding:12px 14px;border:1.5px solid var(--ac);border-radius:12px;background:color-mix(in srgb, var(--ac) 9%, transparent);text-align:center;">
        <div style="font-weight:700;font-size:13.5px;color:var(--ink);">⚠️ Telegram чат — МІНДЕТТІ</div>
        <div style="font-size:12px;color:var(--ink3);margin-top:4px;line-height:1.55;">Квиз <b>8 шілде 21:00</b>-де осы чатта өтеді. Кірмесең — квизге қатыса алмайсың.</div>
        <a href="${esc(m.tg_invite)}" target="_blank" rel="noopener" class="mr-cta-btn mr-cta-tg" style="margin-top:10px;">
          <i class="ti ti-brand-telegram"></i> Чатқа кіру (міндетті)
        </a>
        <button type="button" data-action="regen-invite" style="display:block;margin:8px auto 0;background:none;border:none;color:var(--ink3);font-size:12px;cursor:pointer;text-decoration:underline;">Сілтеме ашылмай ма? Жаңарту</button>
      </div>` : '';
    const sub = phase === 'live'
      ? 'Сәтті оқу! 🔥'
      : (m.tg_invite ? '' : '⚠️ Telegram чаты тіркеуден соң беріледі — квиз сол жерде');
    return `
      ${numHtml}
      <div class="mr-cta-btn mr-cta-done"><i class="ti ti-check"></i> Тіркелдіңіз</div>
      <div class="mr-cta-sub">${sub}</div>
      ${shareBtn}
      ${invite}
    `;
  }

  // 2) Чек жіберілген, бірақ әлі расталмаған.
  if (m.pending_order && !m.is_registered) {
    return `
      <div class="mr-cta-btn mr-cta-soon" aria-disabled="true"><i class="ti ti-clock"></i> Чегіңіз тексерілуде</div>
      <div class="mr-cta-sub">Админ растаған соң тіркелесіз — хабарлама келеді</div>
    `;
  }

  if (phase === 'before_reg') {
    const n = daysUntil(m.reg_open_date);
    const sub = (n !== null && n > 0)
      ? `${n} күннен кейін ашылады`
      : 'Жуырда ашылады';
    // Админге — ашылуын күтпей тест жасауға бөлек батырма.
    const adminTest = m.is_admin ? `
      <button class="mr-cta-btn mr-cta-tg" data-action="open-marathon-reg" style="margin-top:10px;">
        <i class="ti ti-tool"></i> Тіркеуді тест (админ)
      </button>` : '';
    return `
      <div class="mr-cta-btn mr-cta-soon" aria-disabled="true">
        <i class="ti ti-clock"></i>
        Тіркелу ${esc(regDay)}нан басталады
      </div>
      <div class="mr-cta-sub">${esc(sub)} · ${priceFmt} ₸</div>
      ${adminTest}
    `;
  }

  if (phase === 'reg_open') {
    // Блогер рефінен келгендер (pq_ref бар) → САЙТ тіркеуі: атрибуция сақталады
    // (блогерге несие) + логин арқылы telegram_id → растағанда квиз ашылады.
    // Қалғандары → Telegram БОТ (founder шешімі: жалпы бет ботқа өтеді).
    if (_refCode()) {
      return `
        <button type="button" class="mr-cta-btn mr-cta-tg" data-mr-refreg="1">
          <i class="ti ti-flame"></i> Тіркелу — ${priceFmt} ₸
        </button>
        <div class="mr-cta-sub">Тіркелу ашық · ${m.duration_days || 3} күн оқу</div>
      `;
    }
    return `
      <button type="button" class="mr-cta-btn" data-mr-botreg="${esc(botUrl)}">
        <i class="ti ti-brand-telegram"></i> Тіркелу — ${priceFmt} ₸
      </button>
      <div class="mr-cta-sub">Тіркелу ашық · ${m.duration_days || 3} күн оқу</div>
    `;
  }

  if (phase === 'live') {
    // Кеш тіркелу ашық болса (m.reg_late) — марафон жүріп жатса да қосыла береді.
    if (m.reg_late) {
      const btn = _refCode()
        ? `<button type="button" class="mr-cta-btn mr-cta-tg" data-mr-refreg="1">
             <i class="ti ti-flame"></i> Қосылу — ${priceFmt} ₸
           </button>`
        : `<button type="button" class="mr-cta-btn" data-mr-botreg="${esc(botUrl)}">
             <i class="ti ti-brand-telegram"></i> Қосылу — ${priceFmt} ₸
           </button>`;
      return `${btn}
        <div class="mr-cta-sub">Марафон жүріп жатыр — әлі қосыла аласың</div>
      `;
    }
    return `
      <div class="mr-cta-btn mr-cta-soon" aria-disabled="true">
        <i class="ti ti-flame"></i>
        Марафон басталып кетті
      </div>
      <div class="mr-cta-sub">Тіркелу жабылды — келесі марафонды күт</div>
    `;
  }

  // ended
  return `
    <div class="mr-cta-btn mr-cta-done">
      <i class="ti ti-flag"></i>
      Марафон аяқталды
    </div>
    <div class="mr-cta-sub">Жаңа марафон — арнадан хабар</div>
  `;
}

function renderMarathon(m) {
  const bookTitle = m.book_title || m.title || '';
  const bookPages = m.book_pages || null;
  const pricePer = m.reg_price || m.price_kzt || 1000;  // реф болса жеңілдік бағасы (800)
  const refDisc = Number(m.ref_discount) || 0;
  const dailyPages = bookPages ? Math.round(bookPages / Math.max(1, m.duration_days || 3)) : null;
  const dateText = fmtDateRange(m.start_date, m.end_date);
  const recent = Array.isArray(m.recent) ? m.recent : [];
  const count = m.count || 0;
  const botUrl = m.telegram_bot_url || 'https://t.me/oyordabot';
  const prizesArr = (Array.isArray(m.prizes) && m.prizes.length) ? m.prizes : null;

  const phase = marathonPhase(m);
  const regDay = fmtDay(m.reg_open_date);   // "15 маусым"
  const priceFmt = pricePer.toLocaleString('ru-RU').replace(/,/g, ' ');
  const discBadge = refDisc > 0
    ? ` <span style="font-size:11px;color:#3A5C3C;font-weight:700;white-space:nowrap;">−${refDisc}₸ жеңілдік</span>` : '';

  // Hero тіркелу-күйі белгісі
  const regPill = {
    before_reg: regDay ? `<i class="ti ti-clock"></i> Тіркелу ${esc(regDay)}нан ашылады` : '',
    reg_open: `<i class="ti ti-check"></i> Тіркелу ашық`,
    live: `<i class="ti ti-flame"></i> Марафон жүріп жатыр`,
    ended: `<i class="ti ti-flag"></i> Аяқталды`,
  }[phase] || '';

  return `
${topNav()}

<div class="mr-page">

  <!-- HERO -->
  <section class="mr-hero">
    <div class="mr-badge">
      <i class="ti ti-flame"></i>
      PARAQTA МАРАФОНЫ
    </div>

    <div class="mr-cover">
      <div class="mr-cover-text">${esc(bookTitle)}</div>
    </div>

    <h1 class="mr-title">${esc(bookTitle)}</h1>
    ${m.book_author ? `
    <div class="mr-meta">
      ${esc(m.book_author)}${bookPages ? ` · ${bookPages} бет` : ''}${m.book_year ? ` · ${m.book_year}` : ''}
    </div>
    ` : ''}

    ${dateText ? `
    <div class="mr-date-pill">
      <i class="ti ti-calendar"></i>
      ${esc(dateText)}
    </div>
    <div class="mr-date-sub">${m.duration_days || 3} күн</div>
    ` : ''}

    ${regPill ? `<div class="mr-reg-pill mr-reg-${phase}">${regPill}</div>` : ''}
  </section>

  <!-- HOW IT WORKS -->
  <section class="mr-section">
    <div class="mr-eyebrow">ҚАЛАЙ ӨТЕДІ</div>
    <div class="mr-card">
      <div class="mr-step">
        <div class="mr-step-num">1</div>
        <div>
          <div class="mr-step-title">Тіркелу — ${priceFmt} ₸${discBadge}</div>
          <div class="mr-step-desc">${regDay ? `${esc(regDay)}нан ашық · ` : ''}Telegram арқылы</div>
        </div>
      </div>
      <div class="mr-step">
        <div class="mr-step-num">2</div>
        <div>
          <div class="mr-step-title">Telegram чатқа қосылу</div>
          <div class="mr-step-desc">Сілтеме беріледі — тіркелгеннен соң</div>
        </div>
      </div>
      <div class="mr-step">
        <div class="mr-step-num">3</div>
        <div>
          <div class="mr-step-title">${m.duration_days || 3} күн оқу</div>
          <div class="mr-step-desc">${bookPages ? `${bookPages} бет` : 'Кітап'}${dailyPages ? ` · күніне ~${dailyPages} бет` : ''}</div>
        </div>
      </div>
      <div class="mr-step">
        <div class="mr-step-num">4</div>
        <div>
          <div class="mr-step-title">Куиз</div>
          <div class="mr-step-desc">Жауап жазып, жеңімпаздар табылады</div>
        </div>
      </div>
    </div>
  </section>

  <!-- PRIZES -->
  <section class="mr-section">
    <div class="mr-eyebrow">ЖЕҢІМПАЗДАРҒА</div>
    ${prizesArr ? `
    <div class="mr-card" style="padding:4px 16px;">
      ${prizesArr.map((p, i) => `<div style="display:flex;align-items:center;gap:10px;padding:13px 2px;${i < prizesArr.length - 1 ? 'border-bottom:1px solid color-mix(in srgb,var(--ink) 8%,transparent);' : ''}font-size:14.5px;line-height:1.4;color:var(--ink);">${esc(p)}</div>`).join('')}
    </div>
    ` : `
    <div style="text-align:center;font-size:13px;color:var(--ink3);margin:-2px 0 12px;">Жалпы қор: 60 000 ₸ + Foliant баспасынан 10 кітап</div>
    <div class="mr-card">
      <div class="mr-prize mr-prize-gold"><div class="mr-prize-rank">1</div><div class="mr-prize-amount">35 000 ₸ + 5 кітап</div></div>
      <div class="mr-prize mr-prize-silver"><div class="mr-prize-rank">2</div><div class="mr-prize-amount">15 000 ₸ + 3 кітап</div></div>
      <div class="mr-prize mr-prize-bronze"><div class="mr-prize-rank">3</div><div class="mr-prize-amount">10 000 ₸ + 2 кітап</div></div>
    </div>
    <div class="mr-prizes-note">Барлық қатысушыға: старт нөмірі · аяқтаса сертификат · финишер клубы</div>
    `}
  </section>

  <!-- PARTICIPANTS -->
  <section class="mr-section mr-participants">
    <div class="mr-participants-num">${count}</div>
    <div class="mr-participants-label">тіркелген</div>
    ${recent.length > 0 ? `
    <div class="mr-avatars">
      ${recent.slice(0, 5).map(u => `
        <div class="mr-avatar">${esc(String(u.first_name || '?').slice(0, 2).toUpperCase())}</div>
      `).join('')}
      ${count > 5 ? `<div class="mr-avatar mr-avatar-more">+${count - 5}</div>` : ''}
    </div>
    ` : ''}
  </section>

  <!-- CTA — фазаға қарай -->
  <section class="mr-cta-wrap">
    ${renderCta(m, phase, regDay, priceFmt, botUrl)}
    ${(phase === 'reg_open' || phase === 'live') && !(m.is_registered && m.tg_invite) ? `
    <button type="button" data-action="claim-invite" style="display:block;margin:14px auto 0;background:none;border:none;color:var(--ac);font-size:13px;font-weight:600;cursor:pointer;text-decoration:underline;">
      Тіркелдім, бірақ чатта жоқпын →
    </button>` : ''}
  </section>

</div>
  `;
}

// Реф белгісі — тек /b/КОД-пен келгенде («X ұсынады»). Жалпы /marathon-да ЕМЕС.
// pq_ref (localStorage) атрибуция үшін сақталады; көрсету тек pq_ref_show (session) болса.
async function injectRefBadge(node) {
  let show = false;
  try { show = sessionStorage.getItem('pq_ref_show') === '1'; } catch (_) {}
  if (!show) return;
  let code = null;
  try { code = localStorage.getItem('pq_ref'); } catch (_) {}
  if (!code) return;
  try {
    const r = await api('/api/ref/landing/' + encodeURIComponent(code));
    if (!r || !r.ok || !r.name) return;
    const hero = node.querySelector('.mr-hero');
    if (!hero) return;
    const wrap = document.createElement('div');
    wrap.style.cssText = 'text-align:center;margin-bottom:8px;';
    wrap.innerHTML = '<span style="font-size:12px;color:#8A6E3A;background:rgba(168,138,74,.14);border-radius:999px;padding:4px 13px;font-weight:600;">'
      + esc(r.name) + ' ұсынады</span>';
    hero.insertAdjacentElement('afterbegin', wrap);
  } catch (_) {}
}

// Логинсіз тіркеу күйі — order_token localStorage-те болса, растау/чат сілтемесін көрсету.
async function injectOrderStatus(node) {
  let token = null;
  try { token = localStorage.getItem('pq_marathon_order'); } catch (_) {}
  if (!token) return;
  let st = null;
  try { st = await api('/api/marathon/order-status?t=' + encodeURIComponent(token)); } catch (_) { return; }
  if (!st) return;
  const hero = node.querySelector('.mr-hero');
  if (!hero) return;
  const wrap = document.createElement('div');
  wrap.className = 'mr-section';
  if (st.status === 'approved' && st.invite_link) {
    wrap.innerHTML = `<div class="mr-card" style="text-align:center;">
      <div style="font-weight:800;color:#3A5C3C;font-size:16px;margin-bottom:6px;">✅ Тіркелдің! Нөмірің #${st.number || ''}</div>
      <div style="font-size:12.5px;color:var(--ink3);margin-bottom:10px;">Квиз 8 шілде 21:00 — Telegram чатта. Кіру міндетті.</div>
      <a href="${esc(st.invite_link)}" target="_blank" rel="noopener" class="mr-cta-btn mr-cta-tg"><i class="ti ti-brand-telegram"></i> Telegram чатқа кіру</a>
    </div>`;
  } else if (st.status === 'pending') {
    wrap.innerHTML = `<div class="mr-card" style="text-align:center;">
      <div style="font-weight:700;font-size:14px;margin-bottom:4px;">⏳ Чегің тексеруде</div>
      <div style="font-size:12.5px;color:var(--ink3);">Админ растаған соң чат сілтемесі осында шығады.</div>
    </div>`;
  } else {
    if (st.status === 'rejected') { try { localStorage.removeItem('pq_marathon_order'); } catch (_) {} }
    return;
  }
  hero.insertAdjacentElement('afterend', wrap);
}


// ─── Сайт ішілік тіркеу модалы (Kaspi + чек жүктеу) ───────────────
function _escClose(e) { if (e.key === 'Escape') closeRegModal(); }

function closeRegModal() {
  const ov = document.getElementById('mrRegModal');
  if (ov) ov.remove();
  document.removeEventListener('keydown', _escClose);
}

function closeAndReload() { closeRegModal(); loadMarathon(); }

// Тіркелу нұсқауы (модал) → сосын Telegram ботқа өту. Founder: батырма → нұсқау → бот.
// Блогер рефінен келген қонақ → сайтта тіркеу. Квиз бен чат Telegram-да
// болғандықтан логин керек (сонда telegram_id байланады → растағанда боттың
// жазылым тізіміне қосамыз → квиз ашылады). Логин барда — бірден төлем модалы.
function openRefReg() {
  if (window.currentUser) { openRegModal(); return; }
  try { sessionStorage.setItem('pq_marathon_reg', '1'); } catch (_) {}
  showLoginModal();
}

// Логиннен кейін onTelegramAuth осыны шақырады (pq_marathon_reg болса).
export function openRegAfterLogin() {
  if (_m) openRegModal();
}

function openBotRegModal(botUrl) {
  const e = s => String(s ?? '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const step = (n, txt) => `<div style="display:flex;gap:12px;align-items:flex-start;"><div style="flex:none;width:26px;height:26px;border-radius:50%;background:var(--ac);color:#fff;font-weight:700;font-size:13px;display:flex;align-items:center;justify-content:center;">${n}</div><div style="font-size:14px;line-height:1.45;color:var(--ink);">${txt}</div></div>`;
  const ov = document.createElement('div');
  ov.style.cssText = 'position:fixed;inset:0;z-index:400;background:rgba(20,17,12,.8);backdrop-filter:blur(4px);-webkit-backdrop-filter:blur(4px);display:flex;align-items:center;justify-content:center;padding:22px;';
  ov.innerHTML =
    '<div style="max-width:360px;width:100%;background:var(--card);border-radius:22px;padding:26px 22px;box-shadow:0 20px 60px -20px rgba(0,0,0,.5);">' +
      '<div style="font-family:Georgia,serif;font-size:21px;font-weight:600;text-align:center;color:var(--ink);">Тіркелу — 3 қадам</div>' +
      '<div style="display:flex;flex-direction:column;gap:15px;margin-top:20px;">' +
        step(1, 'Telegram бот ашылады → <b>«3 күндік марафон»</b> батырмасын бас') +
        step(2, 'Kaspi-мен <b>1000₸</b> төлеп, <b>чекті (скриншот)</b> ботқа жібер') +
        step(3, 'Админ растайды → бот <b>чат сілтемесін</b> береді') +
      '</div>' +
      '<a href="' + e(botUrl) + '" target="_blank" rel="noopener" data-mr-go style="display:block;text-align:center;margin-top:24px;background:linear-gradient(160deg,#F0B254,#DA942F);color:#2A1E0B;border-radius:14px;padding:15px;font-size:15px;font-weight:700;text-decoration:none;">Ботқа өту →</a>' +
      '<button type="button" data-mr-close style="width:100%;margin-top:9px;background:none;border:none;color:var(--ink3);font-size:13px;cursor:pointer;padding:8px;">Жабу</button>' +
    '</div>';
  document.body.appendChild(ov);
  const close = () => ov.remove();
  ov.addEventListener('click', ev => { if (ev.target === ov) close(); });
  ov.querySelector('[data-mr-close]').addEventListener('click', close);
  ov.querySelector('[data-mr-go]').addEventListener('click', () => setTimeout(close, 150));
}

async function openRegModal() {
  if (!_m) return;
  // Логинсіз тіркеу: телефон + Kaspi + чек. Логин ТАЛАП ЕТІЛМЕЙДІ (қабырға жоқ).
  // Жеңілдік (реф болса 800₸) дұрыс көрінуі үшін — жаңа бағаны ал.
  try {
    const fresh = await api(_currentUrl());
    if (fresh && fresh.marathon) _m = fresh.marathon;
  } catch (_) {}
  const m = _m;
  _regFile = null;
  const priceFmt = (m.reg_price || 1000).toLocaleString('ru-RU').replace(/,/g, ' ');
  const ov = document.createElement('div');
  ov.className = 'mr-modal-ov';
  ov.id = 'mrRegModal';
  ov.innerHTML = `
    <div class="mr-modal" role="dialog" aria-modal="true">
      <button class="mr-modal-x" data-mr="close" aria-label="Жабу"><i class="ti ti-x"></i></button>
      <div class="mr-modal-title">Марафонға тіркелу</div>
      <div class="mr-modal-price">${priceFmt} ₸</div>
      <div class="mr-modal-sub">«${esc(m.book_title || '')}» · ${m.duration_days || 3} күн · ${fmtDateRange(m.start_date, m.end_date) || '6–8 шілде'}</div>

      <div class="mr-modal-step"><span class="mr-modal-num">1</span> Телефон нөміріңді жаз</div>
      <input type="tel" inputmode="tel" data-mr="phone" placeholder="+7 700 000 0000"
        style="width:100%;box-sizing:border-box;padding:13px 14px;border:1.5px solid color-mix(in srgb,var(--ink) 16%,transparent);border-radius:12px;font-size:15px;font-family:inherit;background:var(--bg);color:var(--ink);">

      <div class="mr-modal-step"><span class="mr-modal-num">2</span> Kaspi арқылы <b>${priceFmt} ₸</b> аудар</div>
      <a href="${esc(m.kaspi_url || '#')}" target="_blank" rel="noopener" class="mr-kaspi-btn">
        <i class="ti ti-external-link"></i> Kaspi-де төлеу
      </a>

      <div class="mr-modal-step"><span class="mr-modal-num">3</span> Төлем чегін жүкте</div>
      <label class="mr-drop" data-mr="drop">
        <i class="ti ti-upload"></i>
        <span data-mr="fname">Чек суретін таңда (jpg / png / pdf)</span>
        <input type="file" accept="image/*,.pdf" hidden data-mr="file">
      </label>

      <button class="mr-cta-btn mr-modal-submit" data-mr="submit" disabled>Тіркелуді аяқтау</button>
      <div class="mr-modal-note" data-mr="note"></div>
      <div style="font-size:11.5px;color:var(--ink3);text-align:center;margin-top:8px;line-height:1.5;">Чегіңді админ тексереді. Расталған соң осы жерде Telegram чат сілтемесі шығады.</div>
      <div style="text-align:center;margin-top:12px;padding-top:12px;border-top:1px solid color-mix(in srgb,var(--ink) 9%,transparent);">
        <span style="font-size:12px;color:var(--ink3);">Бұрын чек жібердіңіз бе?</span>
        <button type="button" data-mr="tglogin" style="display:block;margin:6px auto 0;background:none;border:none;color:var(--ac);font-weight:700;font-size:13px;cursor:pointer;"><i class="ti ti-brand-telegram"></i> Telegram-мен кіріп тексеру</button>
      </div>
    </div>`;
  document.body.appendChild(ov);

  ov.addEventListener('click', (e) => { if (e.target === ov) closeRegModal(); });
  ov.querySelector('[data-mr="close"]').addEventListener('click', closeRegModal);
  const fileInput = ov.querySelector('[data-mr="file"]');
  const fnameEl = ov.querySelector('[data-mr="fname"]');
  const submitBtn = ov.querySelector('[data-mr="submit"]');
  const dropEl = ov.querySelector('[data-mr="drop"]');
  const phoneEl = ov.querySelector('[data-mr="phone"]');
  const _refresh = () => {
    // Логин барда телефон міндетті емес (telegram_id-мен танылады).
    const okPhone = !!window.currentUser || (phoneEl.value || '').replace(/\D/g, '').length >= 10;
    submitBtn.disabled = !(okPhone && _regFile);
  };
  phoneEl.addEventListener('input', _refresh);
  fileInput.addEventListener('change', () => {
    _regFile = (fileInput.files && fileInput.files[0]) || null;
    if (_regFile) { fnameEl.textContent = _regFile.name; dropEl.classList.add('has'); }
    else { fnameEl.textContent = 'Чек суретін таңда (jpg / png / pdf)'; dropEl.classList.remove('has'); }
    _refresh();
  });
  submitBtn.addEventListener('click', () => submitRegOrder(ov, submitBtn, phoneEl.value));
  // «Бұрын тіркелдім» — Telegram-мен кіру: логин соңында марафон бетіне қайтады
  // (тіркелген болса «Тіркелдіңіз» + чат сілтемесін көреді, қайта төлемейді).
  ov.querySelector('[data-mr="tglogin"]')?.addEventListener('click', () => {
    try { sessionStorage.setItem('pq_marathon_check', '1'); } catch (_) {}
    closeRegModal();
    showLoginModal();
  });
  document.addEventListener('keydown', _escClose);
}

async function submitRegOrder(ov, btn, phone) {
  if (!_regFile) return;
  const note = ov.querySelector('[data-mr="note"]');
  if (note) { note.textContent = ''; note.classList.remove('err'); }
  if (!window.currentUser && (phone || '').replace(/\D/g, '').length < 10) {
    if (note) { note.textContent = 'Телефон нөмірін дұрыс жаз'; note.classList.add('err'); }
    return;
  }
  btn.disabled = true; btn.textContent = 'Жіберілуде...';
  try {
    const fd = new FormData();
    fd.append('file', _regFile);
    fd.append('phone', phone);
    fd.append('ref', _refCode());  // жеңілдік бағасы + блогер несиесі (реф болса 800₸)
    const res = await fetch('/api/marathon/order', { method: 'POST', body: fd, credentials: 'same-origin' });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.detail || 'Жіберілмеді');
    const token = data.order_token || '';
    if (token) { try { localStorage.setItem('pq_marathon_order', token); } catch (_) {} }
    _renderRegDone(ov, (data.already_registered || data.status === 'approved'), token);
  } catch (err) {
    if (note) { note.textContent = (err && err.message) || 'Қате — қайталап көр'; note.classList.add('err'); }
    btn.disabled = false; btn.textContent = 'Тіркелуді аяқтау';
  }
}

// Тіркеу сәтті — растау күйін тексеретін карта (логинсіз: order_token арқылы).
function _renderRegDone(ov, done, token) {
  const okSub = done ? 'Сіз марафондасыз 🔥' : 'Төлеміңді админ тексеріп жатыр (әдетте тез).';
  ov.querySelector('.mr-modal').innerHTML = `
    <button class="mr-modal-x" data-mr="close" aria-label="Жабу"><i class="ti ti-x"></i></button>
    <div class="mr-modal-ok"><i class="ti ti-circle-check"></i></div>
    <div class="mr-modal-title">${done ? 'Тіркелдіңіз!' : 'Чек жіберілді ✅'}</div>
    <div class="mr-modal-sub">${okSub}</div>
    <div style="margin-top:13px;padding:12px 14px;border:1.5px solid var(--ac);border-radius:12px;background:color-mix(in srgb, var(--ac) 9%, transparent);text-align:left;">
      <div style="font-weight:700;font-size:13.5px;color:var(--ink);">⚠️ Telegram чат — МІНДЕТТІ</div>
      <div style="font-size:12px;color:var(--ink3);margin-top:4px;line-height:1.55;"><b>8 шілде 21:00</b>-дегі квиз сол чатта. Растаудан кейін чат сілтемесі төменде шығады — міндетті түрде кір.</div>
    </div>
    <div data-mr="status" style="margin-top:12px;"></div>
    <button class="mr-cta-btn" data-mr="pushon" style="margin-top:10px;background:#8B5E34;color:#fff;"><i class="ti ti-bell"></i> Квиз ескертуін алу</button>
    <button class="mr-cta-btn mr-modal-submit" data-mr="explore" style="margin-top:10px;"><i class="ti ti-compass"></i> Сайтпен таныс</button>
    <button data-mr="done" style="margin-top:9px;width:100%;background:transparent;border:none;color:var(--ink3);font-size:13px;cursor:pointer;padding:6px;">Кейін — жабу</button>`;
  ov.querySelector('[data-mr="close"]').addEventListener('click', closeAndReload);
  ov.querySelector('[data-mr="done"]').addEventListener('click', closeAndReload);
  ov.querySelector('[data-mr="pushon"]')?.addEventListener('click', () => {
    import('../push/index.js').then(m => m.enablePush('🔔 Ескерту қосылды — квиз алдында хабарлаймыз')).catch(() => {});
  });
  ov.querySelector('[data-mr="explore"]').addEventListener('click', () => {
    document.body.classList.remove('pq-ref', 'pq-ref-guest');
    closeRegModal();
    show('catalog');
  });
  const statusEl = ov.querySelector('[data-mr="status"]');
  const renderStatus = (st) => {
    if (st && st.status === 'approved' && st.invite_link) {
      statusEl.innerHTML = `
        <div style="text-align:center;font-weight:700;color:#3A5C3C;margin-bottom:8px;">✅ Расталды! Нөмірің #${st.number || ''}</div>
        <a href="${esc(st.invite_link)}" target="_blank" rel="noopener" class="mr-cta-btn mr-cta-tg"><i class="ti ti-brand-telegram"></i> Telegram чатқа кіру (міндетті)</a>
        <button data-mr="regen" style="display:block;margin:8px auto 0;background:none;border:none;color:var(--ink3);font-size:12px;cursor:pointer;text-decoration:underline;">Сілтеме ашылмай ма? Жаңарту</button>`;
      statusEl.querySelector('[data-mr="regen"]')?.addEventListener('click', doRegen);
    } else {
      statusEl.innerHTML = `<button class="mr-cta-btn" data-mr="check" style="background:transparent;border:1.5px solid var(--ac);color:var(--ac);"><i class="ti ti-refresh"></i> Растауды тексеру</button>`;
      statusEl.querySelector('[data-mr="check"]')?.addEventListener('click', doCheck);
    }
  };
  const doCheck = async () => {
    if (!token) return;
    try {
      const st = await api('/api/marathon/order-status?t=' + encodeURIComponent(token));
      renderStatus(st);
    } catch (_) {}
  };
  const doRegen = async (e) => {
    const btn = e && e.target;
    if (btn) btn.textContent = 'Жаңартылуда...';
    try {
      await fetch('/api/marathon/regenerate-invite', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin', body: JSON.stringify({ token: token || '' }),
      });
      await doCheck();
    } catch (_) { if (btn) btn.textContent = 'Қате — қайталап көр'; }
  };
  if (token) { renderStatus(null); setTimeout(doCheck, 20000); }
  else { statusEl.remove(); }
}

// ── РЕФ ҚАҚПАСЫ (NFC flywheel секілді) ─────────────────────────────
// Блогер сілтемесімен (/b/CODE немесе ?ref=CODE) келген адам: тіркелмесе
// сайтқа кірмейді әрі төлей алмайды — ТЕК марафон беті көрінеді.
// Логин болса — қалыпты марафон беті (мүше, толық қолжетім).
// main.js bypass осыны шақырады; loginDone (auth) логин соңында қайталайды.
export async function refEntry(code, openReg) {
  let me = null;
  try { me = await api('/api/auth/me'); } catch (_) {}
  const authed = !!(me && me.authenticated);
  if (!authed) {
    // focused + gated: жаһандық нав + «артқа» батырмасы жасырылады (marathon.css)
    document.body.classList.add('pq-ref', 'pq-ref-guest');
  } else {
    document.body.classList.remove('pq-ref', 'pq-ref-guest');
  }
  show('marathon');
  // Founder: /marathon = ТЕК ақпарат беті. Сайттың төлем формасы АВТО-АШЫЛМАЙДЫ.
  // Тіркеу тек «Тіркелу» батырмасымен → нұсқау модалы → Telegram бот.
}

export async function loadMarathon() {
  const node = root();
  if (!node) return;
  node.innerHTML = `${topNav()}<div class="mr-loading">Жүктелуде...</div>`;
  try {
    const data = await api(_currentUrl());
    if (!data || !data.marathon) {
      node.innerHTML = renderEmpty();
      return;
    }
    _m = data.marathon;
    node.innerHTML = renderMarathon(data.marathon);

    // Реф сілтемесімен келсе — «X ұсынады» белгісі (тек pq_ref болса).
    injectRefBadge(node);
    // Логинсіз тіркеу күйі (order_token localStorage-те болса) — растау/чат сілтемесі.
    injectOrderStatus(node).catch(() => {});

    // Реф-тіркеу логиннен қайтты → төлем модалын авто-аш (_m дайын).
    try {
      if (sessionStorage.getItem('pq_marathon_regopen') === '1') {
        sessionStorage.removeItem('pq_marathon_regopen');
        if (window.currentUser) setTimeout(() => openRegModal(), 300);
      }
    } catch (_) {}

    // Квиз картасын инжекциялау (тіркелген қатысушыға + сұрақтар болса).
    injectQuizCard(node).catch(() => {});
    // Сертификат картасы (бот квиз нәтижесі жүктелген болса).
    try { injectCertCard(node, data.marathon); } catch (_) {}

    // Чемпиондар (нәтиже жүктелсе) — hero астына жариялау.
    const champs = data.marathon.champions || [];
    if (champs.length) {
      const medals = ['🥇', '🥈', '🥉'];
      const champHtml = `
        <section class="mr-section">
          <div class="mr-eyebrow">🏆 ЧЕМПИОНДАР</div>
          <div class="mr-card mr-champ-card">
            ${champs.map(c => `
              <div class="mr-champ-row">
                <span class="mr-champ-medal">${medals[c.rank - 1] || ('#' + c.rank)}</span>
                <span class="mr-champ-name">${esc(c.name)}</span>
                <span class="mr-champ-score">${c.score}/${c.total}</span>
              </div>`).join('')}
          </div>
        </section>`;
      const hero = node.querySelector('.mr-hero');
      if (hero) hero.insertAdjacentHTML('afterend', champHtml);
    }

    // Сайт ішілік тіркеу — модал ашу.
    const regBtn = node.querySelector('[data-action="open-marathon-reg"]');
    if (regBtn) regBtn.addEventListener('click', openRegModal);

    // Тіркелу (бот) → нұсқау модалы → Telegram.
    node.querySelectorAll('[data-mr-botreg]').forEach(b =>
      b.addEventListener('click', () => openBotRegModal(b.getAttribute('data-mr-botreg'))));

    // Тіркелу (блогер рефі) → сайт тіркеуі (логин-гейт).
    node.querySelectorAll('[data-mr-refreg]').forEach(b =>
      b.addEventListener('click', openRefReg));

    // Старт нөмірін бөлісу (карта).
    const shareBtn = node.querySelector('[data-action="share-number"]');
    if (shareBtn) shareBtn.addEventListener('click', () => shareNumberCard(_m));

    // Чат сілтемесін жаңарту (бір реттік өшіп қалса).
    const regenBtn = node.querySelector('[data-action="regen-invite"]');
    if (regenBtn) regenBtn.addEventListener('click', async () => {
      regenBtn.textContent = 'Жаңартылуда...';
      try {
        const r = await fetch('/api/marathon/regenerate-invite', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          credentials: 'same-origin', body: '{}',
        });
        const d = await r.json().catch(() => ({}));
        if (d && d.invite_link) {
          const a = node.querySelector('.mr-cta-tg');
          if (a) a.setAttribute('href', d.invite_link);
          regenBtn.textContent = '✅ Жаңартылды — «Чатқа кіру» бас';
        } else { regenBtn.textContent = 'Сәтсіз — қайталап көр'; }
      } catch (_) { regenBtn.textContent = 'Қате — қайталап көр'; }
    });

    // Тіркелген, бірақ чатта жоқ адам — өзін тауып (телефон/Telegram) сілтеме алу.
    const claimBtn = node.querySelector('[data-action="claim-invite"]');
    if (claimBtn) claimBtn.addEventListener('click', openClaimModal);

    // Telegram фоллбэк (сайт тіркеуі өшік болғанда ғана) — explicit open.
    const cta = node.querySelector('[data-marathon-cta]');
    if (cta) {
      cta.addEventListener('click', (e) => {
        const url = cta.getAttribute('data-marathon-cta');
        if (!url) return;
        try { window.open(url, '_blank', 'noopener'); }
        catch (_) { window.location.href = url; }
        e.preventDefault();
      });
    }
  } catch (e) {
    console.error('loadMarathon failed', e);
    node.innerHTML = `${topNav()}<div class="mr-error">Қате — қайта көрейік.</div>`;
  }
}

// ── «Чатқа кір» жаһандық баннері ───────────────────────────────
// Марафонға тіркелген, бірақ Telegram-чатта ЖОҚ адамға сайттың кез
// келген бетінде еске салу — бот жете алмайтындарға (ешқашан /start
// баспаған) ЖАЛҒЫЗ масштабталатын арна. Мүшелікті backend кэштеп
// тексереді (chat-status: «мүше»=тұрақты, «жоқ»=120с TTL → кіргені тез
// білінеді де баннер жоғалады). Session ішінде «×» бассаң қайта шықпайды.
export async function initChatBanner() {
  try {
    if (!window.currentUser) return;
    if (document.getElementById('mrChatBanner')) return;
    if (sessionStorage.getItem('pq_machat_dismiss') === '1') return;
    const d = await api('/api/marathon/chat-status');
    if (!d || !d.registered || d.in_chat !== false || !d.invite) return;
    const bar = document.createElement('div');
    bar.id = 'mrChatBanner';
    bar.className = 'mr-chat-banner';
    bar.innerHTML = `
      <span class="mr-cb-ico">🏁</span>
      <span class="mr-cb-txt"><b>Марафон чаты:</b> Telegram-чатқа кіруді ұмытпаңыз — квиз бен барлық жаңалық сол жерде.</span>
      <a class="mr-cb-go" href="${esc(d.invite)}" target="_blank" rel="noopener">Чатқа кіру</a>
      <button class="mr-cb-x" type="button" aria-label="Жабу">×</button>`;
    document.body.appendChild(bar);
    const close = () => { bar.remove(); };
    bar.querySelector('.mr-cb-x').addEventListener('click', () => {
      try { sessionStorage.setItem('pq_machat_dismiss', '1'); } catch (_) {}
      close();
    });
    // Чатқа кіргеннен кейін баннер керек емес — жауып қоямыз (кэш 120с-та
    // жаңарады, келесі кіргенде мүлде шықпайды).
    bar.querySelector('.mr-cb-go').addEventListener('click', () => setTimeout(close, 500));
  } catch (_) { /* үнсіз — баннер маңызды емес */ }
}

// ── «Тіркелдім, бірақ чатта жоқпын» — өзін-өзі тауып чат сілтемесін алу ──
// Марафон басталды, ~40 адам чатта жоқ. Логинсіз (тек телефон) тіркелгендер
// бетте танылмайды. Осы модал: телефон НЕМЕСЕ Telegram-мен кіру → backend
// approved тапсырысты тексеріп (чегі расталған ба), бір реттік invite береді.
function openClaimModal() {
  const ov = document.createElement('div');
  ov.className = 'mr-claim-ov';
  ov.style.cssText = 'position:fixed;inset:0;z-index:600;background:rgba(28,26,22,.55);display:flex;align-items:flex-end;justify-content:center;';
  ov.innerHTML = `
    <div style="background:var(--card);width:100%;max-width:460px;border-radius:20px 20px 0 0;padding:22px 20px calc(22px + env(safe-area-inset-bottom));font-family:'Onest',system-ui,sans-serif;">
      <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:6px;">
        <div style="font-size:17px;font-weight:700;color:var(--ink);">Марафон чатына кіру</div>
        <button type="button" data-claim="close" aria-label="Жабу" style="background:none;border:none;font-size:24px;color:var(--ink3);cursor:pointer;line-height:1;">×</button>
      </div>
      <div style="font-size:13px;color:var(--ink3);line-height:1.5;margin-bottom:16px;">Тіркелген болсаңыз — өзіңізді тауып, чат сілтемесін алыңыз. Чегіңіз <b>расталған</b> соң ғана беріледі.</div>
      <div style="font-size:12px;color:var(--ink3);font-weight:600;margin-bottom:6px;">Тіркелген нөміріңіз</div>
      <input type="tel" inputmode="numeric" data-claim="phone" placeholder="87071234567" style="width:100%;height:46px;border:1px solid var(--bg4);border-radius:12px;padding:0 14px;font-size:15px;font-family:inherit;background:var(--bg);color:var(--ink);margin-bottom:10px;">
      <button type="button" data-claim="find" class="mr-cta-btn" style="width:100%;"><i class="ti ti-search"></i> Чат сілтемесін алу</button>
      <div style="text-align:center;font-size:12px;color:var(--ink4);margin:14px 0;">немесе</div>
      <button type="button" data-claim="tg" class="mr-cta-btn mr-cta-tg" style="width:100%;"><i class="ti ti-brand-telegram"></i> Telegram-мен кіру</button>
      <div data-claim="result" style="margin-top:14px;"></div>
    </div>`;
  document.body.appendChild(ov);
  const result = ov.querySelector('[data-claim="result"]');
  const close = () => ov.remove();
  ov.addEventListener('click', (e) => { if (e.target === ov) close(); });
  ov.querySelector('[data-claim="close"]').addEventListener('click', close);

  const msg = (t, warn) => `<div style="font-size:13px;color:${warn ? 'var(--danger)' : 'var(--ink3)'};text-align:center;line-height:1.5;">${t}</div>`;
  function showResult(d) {
    if (d && d.ok && d.invite_link) {
      result.innerHTML = `<div style="padding:14px;border:1.5px solid var(--ac);border-radius:12px;background:color-mix(in srgb,var(--ac) 9%,transparent);text-align:center;">
        <div style="font-weight:700;color:#3A5C3C;margin-bottom:8px;">✅ Табылды! Чатқа кіріңіз</div>
        <a href="${esc(d.invite_link)}" target="_blank" rel="noopener" class="mr-cta-btn mr-cta-tg"><i class="ti ti-brand-telegram"></i> Telegram чатқа кіру</a>
      </div>`;
    } else if (d && d.reason === 'pending') {
      result.innerHTML = msg('Чегіңіз әлі тексерілуде. Расталған соң қайта көріңіз.', true);
    } else {
      result.innerHTML = msg('Бұл нөмірмен тіркеу табылмады. Дұрыс нөмірді жазыңыз немесе алдымен тіркеліңіз.', true);
    }
  }
  async function doFind() {
    const phone = ((ov.querySelector('[data-claim="phone"]').value) || '').replace(/\D/g, '');
    if (phone.length < 10) { result.innerHTML = msg('Нөмірді толық жазыңыз (10+ цифр).', true); return; }
    const btn = ov.querySelector('[data-claim="find"]');
    btn.disabled = true; btn.innerHTML = 'Тексерілуде...';
    try {
      const fd = new FormData(); fd.append('phone', phone);
      const r = await fetch('/api/marathon/claim-invite', { method: 'POST', body: fd, credentials: 'same-origin' });
      showResult(await r.json().catch(() => ({})));
    } catch (_) { result.innerHTML = msg('Қате — қайталап көріңіз.', true); }
    btn.disabled = false; btn.innerHTML = '<i class="ti ti-search"></i> Чат сілтемесін алу';
  }
  ov.querySelector('[data-claim="find"]').addEventListener('click', doFind);
  ov.querySelector('[data-claim="phone"]').addEventListener('keydown', (e) => { if (e.key === 'Enter') doFind(); });
  ov.querySelector('[data-claim="tg"]').addEventListener('click', async () => {
    if (window.currentUser) {
      try {
        const r = await fetch('/api/marathon/claim-invite', { method: 'POST', credentials: 'same-origin' });
        showResult(await r.json().catch(() => ({})));
      } catch (_) { result.innerHTML = msg('Қате — қайталап көріңіз.', true); }
    } else {
      try { sessionStorage.setItem('pq_marathon_check', '1'); } catch (_) {}
      showLoginModal();
    }
  });
}

export function marathonBack() {
  show('oqu');
}
